// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3yZ_l","rootSmall":"AddTileButton_rootSmall__I5TCz"};